import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'We need the following documents. You can fill them in any order you wish.',
    hostId: 'Identity verification of your host',
    hostIdDescription: 'You’ll need your host’s ID.',
    next: 'Continue',
    proofOfAccommodation: 'A proof of accommodation',
    proofOfAccommodationDescription: 'This is a document signed by your host.',
    proofOfAddress: 'A proof of address',
    proofOfAddressDescription:
      'It must mention the name of your host and be less than 3 months old.',
    selfHostedLink: 'I have a document in my name',
    title: 'You’re hosted',
  },
  fr: {
    description:
      'Nous avons besoin des documents suivants. Vous pouvez les remplir dans l’ordre que vous souhaitez.',
    hostId: 'Une pièce d’identité de votre hébergeur',

    hostIdDescription:
      'Vous aurez besoin de la carte d’identité, du passeport, ou titre de séjour de votre hébergeur.',
    next: 'Continuer',
    proofOfAccommodation: 'Une attestation d’hébergement',
    proofOfAccommodationDescription:
      'C’est un document signé par votre hébergeur.',
    proofOfAddress: 'Un justificatif de domicile',
    proofOfAddressDescription:
      'Il doit être au nom de votre hébergeur et dater de moins de 3 mois.',
    selfHostedLink: 'J’ai un document à mon nom',
    title: 'Vous êtes hébergé·e',
  },
} as const);

export default locales;
